import * as React from "react";
import PropTypes from 'prop-types';

const SvgCartLine = props => {
  if (props.id !== "_svgcartline") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 40 40" {...props}><path d="M30.077 23.989l1.932-10.956a1 1 0 011.158-.811l.142.025a1 1 0 01.81 1.158l-2.097 11.9v.01a1 1 0 01-1 1h-17.07a1 1 0 01-1-1v-.006l-2.5-14.165H7a1 1 0 01-1-1V10a1 1 0 011-1h4.432a1 1 0 011 1v.017l2.463 13.972h15.182zM16.58 33a2.512 2.512 0 110-5.025 2.512 2.512 0 010 5.025zm11.166 0a2.512 2.512 0 110-5.025 2.512 2.512 0 010 5.025z" fillRule="evenodd" /></svg>;
};

SvgCartLine.displayName = "_svgcartline";
SvgCartLine.propTypes = {
  id: PropTypes.string
};
SvgCartLine.defaultProps = {
  id: ''
};
export default SvgCartLine;